<template>
  <div>
    <RadioGroup v-model="selectValue" @on-change="getSelect">
      <Radio :label="ele.code" v-for="(ele, index) in dicList" :key="index">{{ ele.name }}</Radio>
    </RadioGroup>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    dicName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectValue: '',
      appCode: 'bsp',
      dicList: []
    }
  },
  watch: {
    dicName: {
      handler(n, o) {
        n ? this.getData() : ''
      },
      deep: true,
      immediate: true
    },
    value: {
      handler(n, o) {
        if (n) {
          this.$set(this, 'selectValue', n)
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getData() {
      let names = this.dicName.split(',').map(item => item.trim()).filter(item => item)
      Promise.all(names.map(dicName => {
        return this.$store
          .dispatch('authGetRequest', {
            url: `/bsp-com/static/dic/${this.appCode}/${dicName}.js`
          })
          .then(res => {
            let numTon = eval('(' + res + ')')
            return numTon()
          }).catch(() => {
            return []
          })
      })).then(datas => {
        let arr = []
        datas.forEach(rows => {
          arr = arr.concat(rows)
        })
        this.dicList = arr
      })
    },
    getSelect(data) {
      this.$emit('input', this.selectValue)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/component/data-grid/components/data-radio.vue